import styled from 'styled-components';
import Colors from 'assets/Colors.js';

const BodyContainer = styled.div`
  max-width: 1057px;
  margin: auto;
  margin-top: 38px;
  padding-left: 12px;
  padding-right: 12px;
  padding-bottom: 49px;
`;

const BottomButtonsContainer = styled.div`
  display: flex;
  margin-top: 49px;
  justify-content: flex-end;
  align-items: center;
`;

const DeleteContainer = styled.div`
  color: ${Colors.notification_failed};
  padding: 5px;
  margin-right: 40px;
  cursor: pointer;
`;

export default {
  BodyContainer,
  BottomButtonsContainer,
  DeleteContainer,
};
